import { Toaster } from "@gigpro/ui/Toast";
import { TooltipProvider } from "@gigpro/ui/Tooltip";
import { Outlet } from "@tanstack/react-router";
import { HalloweenEffects } from "components/Halloween/Effects";
import { LaunchDarklyProvider, useMarketplaceOverhaul } from "providers/LaunchDarkly";
import React from "react";
import { createPortal } from "react-dom";

const Devtools = React.lazy(() => import("./Devtools"));

const ThemeSync = () => {
  const overhaul = useMarketplaceOverhaul("theme");
  React.useEffect(() => {
    document.documentElement.dataset.theme = overhaul ? "overhaul" : "";
  }, [overhaul]);
  return null;
};

const devtoolsEnabled = import.meta.env.DEV && localStorage.getItem("devtools") === "on";

export const RootProvider = () => (
  <LaunchDarklyProvider>
    <ThemeSync />
    <HalloweenEffects />
    {devtoolsEnabled &&
      createPortal(
        <React.Suspense>
          <Devtools />
        </React.Suspense>,
        document.body,
      )}
    <TooltipProvider delayDuration={300}>
      <Toaster />
      <Outlet />
    </TooltipProvider>
  </LaunchDarklyProvider>
);
